/**
 * Re-export shim — the canonical Dialog now lives in `@birdwatch/ui`.
 * Import from `@birdwatch/ui` directly in new code; this path is kept so existing
 * imports keep working during migration. See docs/webapp/dialogs.md.
 */
export {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from "@birdwatch/ui";
